import { styled } from "@mui/material/styles";
import cslx from "clsx";
import React, { FunctionComponent } from "react";
import FlexRowCenter, { FlexRowCenterProps } from "../flex/FlexRowCenter";
import { bannerStyle } from "designSystem/styles/style-functions";

const PREFIX = "Banner";

const classes = {
	root: `${PREFIX}root`,
};

const StyledFlexRowCenter = styled(FlexRowCenter)(({
	theme,
}) => ({
	[`&.${classes.root}`]: bannerStyle(theme),
}));

const Banner: FunctionComponent<FlexRowCenterProps> = (props) => {
	const { className, ...otherProps } = props;

	return (
		<StyledFlexRowCenter
			borderBottom={1}
			flexShrink={0}
			{...otherProps}
			className={cslx(className, classes.root)}
		/>
	);
};

export default Banner;